import moment from "moment";

export const getCurrentTimestamp = () => {
	const time = new Date().getTime();
	const timestamp = Math.floor(time / 1000);
	return timestamp;
};
export const getTimestampFromNow = (timestamp) => {
	return moment(timestamp).fromNow();
};
